export const getCanSendPricingRequest = (numCourses: string, numStudents: string) => {
  if (numCourses === '10+') return true;
  if (numStudents === '500+') return true;
  return false;
};
